"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var common_styles_1 = require("@next-components/common-styles");
var Icon_styled_1 = require("../Icon.styled");
exports.Checkbox = function (initialProps) {
    var variant = initialProps.variant, className = initialProps.className, props = tslib_1.__rest(initialProps, ["variant", "className"]);
    switch (props.checked) {
        case true:
            return (React.createElement(Icon_styled_1.StyledSvg, { width: "30px", height: "30px", viewBox: "0 0 30 30", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                    React.createElement("g", { id: "Abo_checked_farge" },
                        React.createElement("g", { id: "Group" },
                            React.createElement("g", { id: "Group-6-Copy-2", fill: props.fill || common_styles_1.black },
                                React.createElement("circle", { id: "Oval-4-Copy-7", cx: "15", cy: "15", r: "15" })),
                            React.createElement("polyline", { id: "Path-5", stroke: common_styles_1.white, strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round", points: "10 15.1910127 13.8962363 18.8299999 20.9279999 12" }))))));
        case false:
        default:
            return (React.createElement(Icon_styled_1.StyledSvg, { width: "30px", height: "30px", viewBox: "0 0 30 30", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                    React.createElement("g", { id: "Abo_checked_uncheck", fill: props.fill || common_styles_1.stateInactive, stroke: props.stroke || common_styles_1.black, strokeWidth: "2" },
                        React.createElement("g", { id: "Group-6-Copy-2", transform: "translate(1.000000, 1.000000)" },
                            React.createElement("circle", { id: "Oval-4-Copy-7", cx: "14", cy: "14", r: "14" }))))));
    }
};
//# sourceMappingURL=checkbox.js.map